import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';

import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import SandAlarmTestSection from '../../Sections/SandAlarmTestSection/SandAlarmTestSection';
import BorderedBox from '../../BorderedBox';
import FailureModeSection from '../../Sections/FailureModeSection/FailureModeSection';

const P66Form = (props) => (
    <Form
        formName={FormNames.P66}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <DeviceTypesSection />
        <HMISection />
        <VisualInspectSection />
        <BorderedBox>
            <AsFoundTestTableSection />
        </BorderedBox>
        <FailureModeSection />
        <BorderedBox>
            <AsLeftTestTableSection />
        </BorderedBox>
        <BorderedBox>
            <SandAlarmTestSection />
        </BorderedBox>
        <TestResultSection />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P66Form);
